import React from 'react';
import ProductRow from '../components_common/ProductRow';

export const generateProductRows = (
  productRows,
  s3BasePath,
  currencySymbol,
  isDesktop,
  showSale,
  rowsToLoadEagerlyCount,
  placeholderHeight,
  placeholderWidth,
) => {
  return productRows.map((productRow, idx) => (
    <ProductRow
      currencySymbol={currencySymbol}
      isDesktop={isDesktop}
      lazyLoad={rowsToLoadEagerlyCount ? idx >= rowsToLoadEagerlyCount : null}
      placeholderHeight={placeholderHeight}
      placeholderWidth={placeholderWidth}
      productRow={productRow}
      s3BasePath={s3BasePath}
      showSale={showSale}
    />
  ));
};
